<template>
  <div>
        <div class="region-box pull-left">
         <button class="back pull-left">
             <img src="../../images/corner-up-left@2x.png" @click="jump('/ib_v2/ibSetting')" style="width:24px;margin-top:3px;">
         </button>
         <div class="btn-group pull-left" v-if="apiChangeable && $route.path.split('/')[2] !== 'ibCommissionSetting'">
            <button class="btn btn-default" v-for="(item) in area" :class="{'active':  item == actArea}" @click="areaGroupSwitchFn(item)">
              {{item}}
            </button>
         </div>
         <div class="btn-group pull-left" v-else>
            <button class="btn btn-default" v-for="(item,key) in area" :class="{'active':  item == actArea}">
              {{item}}
            </button>
         </div>
         <div class="clear"></div>
        </div>
        <btn-group class="primary-box pull-right">
            <btn :class="{'active': (activePrimary == '/ibSetting' || activePrimary == '/ibCommissionSetting')}" @click="jump('/ib_v2/ibSetting')">
               {{ibPrimaryLan.commissionSetting}}
            </btn>
            <Dropdown class="pull-left seekDropdown" style="margin-left:-1px">
                <button data-role="trigger" class="btn btn-default dropdown-toggle" :class="{'active': activePrimary.indexOf('Result')!= -1}" type="button" @click="checkCpaFn">
                    <span>{{ibPrimaryLan.ibResult.title}}</span>
                    <span class="caret"></span>
                </button>
                <template slot="dropdown" v-for="(item,index) in ibPrimaryLan.ibResult_v2.list">
                    <li @click="jump(item.link)" :class="{'active': activePrimary == item.link}" v-if="item.link !== '/ib_v2/CPACommissionResult' || checkCpa">
                        <a href="javascript:;">{{item.text}}</a>
                    </li>
                </template>
            </Dropdown>
            <Dropdown class="pull-left seekDropdown" style="margin-left:-1px" menu-right>
                <button data-role="trigger" class="btn btn-default dropdown-toggle" :class="{'active': activePrimary.indexOf('Report')!= -1}" type="button">
                    <span>{{ibPrimaryLan.ibReport.title}}</span>
                    <span class="caret"></span>
                </button>
                <template slot="dropdown" v-for="(item,index) in ibPrimaryLan.ibReport_v2.list">
                    <li @click="jump(item.link)" :class="{'active': activePrimary == item.link}">
                        <a href="javascript:;">{{item.text}}</a>
                    </li>
                </template>
            </Dropdown>
        </btn-group>
        <div class="clear"></div>
        <router-view :curArea="curArea" :status="status"></router-view>
  </div>
</template>
<script>
import { BtnGroup,Btn,Dropdown, } from 'uiv'
import { URL_TOOLCHECKCPA } from 'api/commissionApi'
import { Api } from 'api/commissionEnv'
var api = new Api()
export default {
  props: ['status'],
  mixins: [
    require("common/mixin/base.js").base({ibPrimaryLan:"ibPrimary"}),
  ],
  data () {
      return {
          apiChangeable: api.changeable,
          path: '/commissionView/ibPrimary',
          activeName: 'first',
          actArea:JSON.parse(sessionStorage.currentArea20).value,
          curAreaGroup: this.$route.query.role ? this.$route.query.role.split('$')[1] : this.$route.query.region ? this.$route.query.region : JSON.parse(sessionStorage.currentArea20).group,
          checkCpa: false,
      }
  },
  components: {
      BtnGroup,
      Btn,
      Dropdown
  },
  computed:{
      activePrimary: {
          get () {
            return this.$route.path.slice(this.$route.path.lastIndexOf('/'))
          },
          set () {}
      },
      area () {
        const area_data = JSON.parse(sessionStorage.area20)
        const values = Object.values(area_data)
        return Array.from(new Set(values.flat(Infinity)))
        // return area_data
      },
      curArea: {
        get () {
          let res = ''
          if (!this.actArea) {
              res = this.area[0]
          }
          else res = this.actArea
          return res
        },
        set (newValue) {
          this.actArea = newValue
        }
      }
  },
  methods:{
      jump (link) {
          sessionStorage.removeItem('back')
        // this.$router.push({path: this.path+link})
          this.$router.push(link)
          this.activePrimary = link
      },
      checkCpaFn () {
          this.$http(api.getUrl20(this.curArea,URL_TOOLCHECKCPA)).then(res => {
              if (res.data.code == 200 && res.data.data && res.data.msg == 'OK') {
                   this.checkCpa = res.data.data.cpaCheck
              }
          })
      },
      areaGroupSwitchFn (key) {
        this.curArea = key
        let currentArea = JSON.parse(sessionStorage.currentArea20)
        currentArea.value = key
        sessionStorage.currentArea20 = JSON.stringify(currentArea)
      }
  },
  watch: {
      curAreaGroup () {
          this.actArea = ''
          let currentArea = JSON.parse(sessionStorage.currentArea20)
          currentArea.value = this.area[0]
          sessionStorage.currentArea20 = JSON.stringify(currentArea)
      }
  }
}
</script>

<style lang="scss" scoped>
 .back{
     border-color: transparent;
     background-color: transparent;
 }
 .back:hover{
     background-color: #f9f9f9;
     border-radius: 3px;
 }
 .tabs{
     display: inline-block;
     margin-left: 120px;
 }
 .region-box{
     margin-left: 20px;
     position: relative;
     .btn-group{
         margin-left: 20px;
         .active{
             background-color: #F08712;
             color: #fff;
         }
     }
     .area-box {
         margin-top: 10px;
         margin-left: 60px;
     }
 }
 .primary-box{
     margin-right: 20px;
     .active{
         background: #3F51B5;
         color: #fff;
     }
 }
//  .btn-default:active:hover, .btn-default.active:hover, .open > .dropdown-toggle.btn-default:hover, .btn-default:active:focus, .btn-default.active:focus, .open > .dropdown-toggle.btn-default:focus, .btn-default:active.focus, .btn-default.active.focus, .open > .dropdown-toggle.btn-default.focus{
//      background: #3F51B5;
//      color: #fff;
//  }

</style>



// WEBPACK FOOTER //
// ibPrimary.vue?49fff1cf